import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@fontsource/poppins/300.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@fontsource/poppins/400.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@fontsource/poppins/500.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@fontsource/poppins/700.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material-nextjs/esm/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["ViewTransitions"] */ "/vercel/path0/node_modules/next-view-transitions/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/ui/components/theme/ThemeColorMeta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/ui/layouts/AppLayout.tsx");
